import axios from 'axios';
import { fetchStateMock } from '../mocks/state';

const state = {
  fetching: false,
  fetched: false,

  stage: null,
};

const mutations = {
  fetchingStart(state) {
    state.fetching = true;
  },
  fetchingSuccess(state, data) {
    state.fetching = false;
    state.fetched = true;

    state.stage = data.stage;
  },
  fetchingError(state) {
    state.fetching = false;
    state.fetched = true;
  },
  invalidate(state) {
    state.fetched = false;
  },
};

const actions = {
  async fetch({ state, commit }) {
    if (state.fetched) {
      return Promise.resolve();
    }

    commit('fetchingStart');

    try {
      const fetchState = process.env.NODE_ENV === 'development'
        ? await fetchStateMock()
        : await axios.get('/state');

      const { data } = fetchState;

      if (data.error) {
        commit('fetchingError', data.message);
        throw new Error(data.message);
      }
      commit('fetchingSuccess', data);
    } catch (error) {
      alert(error);
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
